import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Grid,
  Paper,
} from "@material-ui/core";

import { countInRange, consolidateTotals } from "./folioMatrixLogic";

function TotalCard({ etiqueta, valor }) {
  return (
    <Grid item xs={6} sm={3}>
      <Paper variant="outlined" style={{ padding: 12, textAlign: "center" }}>
        <Typography variant="h5">{valor}</Typography>
        <Typography variant="body2" color="textSecondary">
          {etiqueta}
        </Typography>
      </Paper>
    </Grid>
  );
}

export default function FolioRangeSummary({ modalidades, asignados, reservados }) {
  if (!modalidades.length) {
    return (
      <Box mb={3}>
        <Typography color="textSecondary">
          Ninguna modalidad tiene un rango de folios (desde/hasta) configurado todavía.
        </Typography>
      </Box>
    );
  }

  // Consolidado del evento: suma los rangos de todas las modalidades tal
  // cual (no deduplica números que se repitan entre modalidades) — si dos
  // modalidades comparten el mismo rango (ej. 1-1000 cada una), el total
  // consolidado refleja la capacidad de inscripción combinada (2 x 1000),
  // no la cantidad de números físicos distintos.
  const consolidado = consolidateTotals(modalidades, asignados, reservados);

  return (
    <Box mb={3}>
      <Typography variant="subtitle1" gutterBottom>
        Consolidado del evento
      </Typography>
      <Grid container spacing={2} style={{ marginBottom: 24 }}>
        <TotalCard etiqueta="Folios totales" valor={consolidado.total} />
        <TotalCard etiqueta="Asignados" valor={consolidado.asignados} />
        <TotalCard etiqueta="Reservados" valor={consolidado.reservados} />
        <TotalCard etiqueta="Libres" valor={consolidado.libres} />
      </Grid>

      <Typography variant="subtitle1" gutterBottom>
        Resumen por modalidad
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Modalidad</TableCell>
              <TableCell align="right">Desde</TableCell>
              <TableCell align="right">Hasta</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Asignados</TableCell>
              <TableCell align="right">Reservados</TableCell>
              <TableCell align="right">Libres</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modalidades.map((m) => {
              const counts = countInRange(m.desde, m.hasta, asignados, reservados);
              return (
                <TableRow key={m.codigo}>
                  <TableCell>{m.label}</TableCell>
                  <TableCell align="right">{m.desde}</TableCell>
                  <TableCell align="right">{m.hasta}</TableCell>
                  <TableCell align="right">{counts.total}</TableCell>
                  <TableCell align="right">{counts.asignados}</TableCell>
                  <TableCell align="right">{counts.reservados}</TableCell>
                  <TableCell align="right">{counts.libres}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

FolioRangeSummary.propTypes = {
  modalidades: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string,
      label: PropTypes.string,
      desde: PropTypes.number,
      hasta: PropTypes.number,
    })
  ).isRequired,
  asignados: PropTypes.instanceOf(Set).isRequired,
  reservados: PropTypes.instanceOf(Set).isRequired,
};
